<input #inputShares [value]="params.value" (keypress)="onKeyPress($event)" (keydown)="onKeyDown($event)"
    class="sdps-input sdps-input--small" />